import React, {useState} from "react";
import Price from "../../tool/Price";
import Common from "../../tool/Common";
import Currency from "../../tool/Currency";
import EmptyBasket from "./EmptyBasket";
import AddBasketLine from "../AddToBasketButton/AddBasketLine";
import AddWishlistInList from "../AddWishlistButton/AddWishlistInList";
import CounterControl from "../AddToBasketButton/CounterControls";
import RestRequest from "../../tool/RestRequest";
import config from "../../config";
import NotAvailableItem from "./NotAvailableItem";

export default function Basket({items}) {

    const [basket, setBasket] = useState(items);
    const [isLoading, setIsLoading] = useState('');

    function showBasePrice(price) {
        return <>
            <div className="basket-item-price">{Price.format(price)} {Currency.show()}</div>
        </>
    }

    function showBasePriceWithDiscount(price, discount) {
        return <>
            <div className="basket-item-price-old">{Price.format(price)} {Currency.show()}</div>
            <div className="basket-item-price-discount">{Price.format(discount)} {Currency.show()}</div>
        </>
    }

    function removeItem(productId) {
        let basketItems = basket;

        basketItems = basketItems.filter(el => {
            return parseInt(el.id) !== parseInt(productId);
        });

        setBasket(basketItems);
    }


    function clearBasket() {
        items.map(model => {

            RestRequest.delete(config.restBasket, model.id).then(result => {
                if (result.data.status === 200) {
                }
            });
        });

        setBasket([]);
    }

    function total() {
        let total = 0;
        basket.map(basketElement => {
            total += parseFloat(basketElement.price.roundedPrice) * basketElement.basket_count;
        });

        return total;
    }

    if (!basket || basket.length === 0) {
        return <EmptyBasket/>
    }

    return <div className={`basket-container ${isLoading}`}>
        <div className="basket-wrapper">

            <div className="basket-clear">
                <div className="basket-clear__button" onClick={clearBasket.bind(this)}>Очистить корзину</div>
            </div>

            <div className="basket">

                {basket.map((element, index) => {

                    console.log(element);

                    let priceHtml = 'Не указано';

                    if (element.price) {
                        // priceHtml = element.price.discount > 0 ? showBasePriceWithDiscount(element.price.base, element.price.discount) : showBasePrice(element.price.base);
                        priceHtml = showBasePrice(element.price.roundedPrice);
                    }

                    if (!element.isAvailable) {
                        return <NotAvailableItem key={index} element={element} actions={{
                            setLoading: setIsLoading,
                            remove: removeItem,
                        }}/>
                    } else {


                        return <div key={index} className="basket-item">
                            <a className="basket-item-image-wrap" href={element.detailPageUrl}>
                                <img className="basket-item-image" src={element.detailImageSrc}/>
                            </a>

                            <div className="basket-item-info">
                                <a href={element.detailPageUrl} className="basket-item-name site-link">{Common.htmlDecode(element.name)}</a>
                                <div className="basket-item-article">Артикул: {element.article}</div>
                                <div className="basket-item-action">

                                    <AddWishlistInList
                                        theme='line'
                                        product_id={element.id}
                                    />

                                    <AddBasketLine
                                        actions={
                                            {
                                                setLoading: setIsLoading,
                                                remove: removeItem,
                                            }
                                        }
                                        productId={element.id}
                                    />
                                </div>
                                <div className="basket-item-manage">
                                    <CounterControl
                                        product_id={element.id}
                                        params={{
                                            setBasket: setBasket,
                                            total: total,
                                            removeItem: removeItem,
                                        }}
                                        count={element.basket_count}/>
                                </div>
                            </div>
                            <div className="basket-item-price-group">
                                {priceHtml}
                            </div>
                        </div>
                    }
                })}
            </div>
        </div>
        <div className="basket-info-container">
            <div className="basket-info">
                <div className="basket-info-item title">
                    <div className="basket-info-item-key">Товары, {basket.length} шт.</div>
                    <div className="basket-info-item-value">{Price.format(total())} {Currency.show()}</div>
                </div>
            </div>
            <a className="btn-main" href="/checkout/">Перейти к оформлению</a>
            <a className="btn-inner" href="/catalog/">Перейти в каталог</a></div>
    </div>
}